module.exports = __webpack_public_path__ + "img/1528638756.2beb65ad.jpg";